import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FormDrawer from "components/__new/common/form-drawer";
import validate from "utils/validate";
import { toast } from "react-toastify";
import { ButtonLoader, SelectInput } from "../common/form";
import numberOrdinalSuffix from "utils/numberOrdinalSuffix";
import * as settingsAction from "store/entities/settingsInfo/action";
import PageContent from "../common/PageContent";
import Maybe from "../common/Maybe";


const ODPConfiguration = (props) => {
    const {isOpen, setIsOpen} = props;
    const dispatch = useDispatch();
    const { odpConfigurationLoading, odpConfiguration, updateODPConfigurationLoading, updateODPConfiguration } = useSelector((state) => state.entities.settingsInfo);
    
    const [form, setForm] = useState({
        payrollCutOff: "",
        paymentFee: "",
        autoWithdrawals: null,
        withdrawalPercent: ""
    })
    
    const getODPConfiguration = () => {
        dispatch(settingsAction.getODPConfiguration());
    }
    
    const submitForm = async (e) => {
        e.preventDefault();
        const errors = validate(form);
        if (errors){
            for (var x in errors) {
                toast.error(errors[x]);
            };
            return;
        }
        else{
            const params = {
                ...form,
                autoWithdrawals: form.autoWithdrawals === "true" ? true : false,
                withdrawalPercent: Number(form.withdrawalPercent),
            }
            dispatch(settingsAction.updateODPConfiguration(params));
        }
    }
    
    useEffect(() => {
        getODPConfiguration();
        // eslint-disable-next-line
    }, [])
    
    useEffect(() => {
        if (odpConfiguration?.status === "success"){
            setForm({
                payrollCutOff: odpConfiguration?.data?.payrollCutOff,
                paymentFee: odpConfiguration?.data?.paymentFee,
                autoWithdrawals: odpConfiguration?.data?.autoWithdrawals === true ? "true":"false",
                withdrawalPercent: odpConfiguration?.data?.withdrawalPercent,
            })
        }
        // eslint-disable-next-line
    }, [odpConfiguration])
    
    useEffect(() => {
        if (updateODPConfiguration?.status === "success"){
            dispatch(settingsAction.resetUpdateODPConfiguration());
            setIsOpen(false);
        }
        // eslint-disable-next-line
    }, [updateODPConfiguration])
    
    return (
        <FormDrawer display="center" size="lg" isOpen={isOpen} setIsOpen={setIsOpen}>
            <div className="p-6">
                <FormDrawer.Title
                    title="On-Demand Pay Configuration"
                    description="Configure your account to start using On-Demand Pay"
                    showCloseButton={false}
                    close={setIsOpen}
                />
                
                <PageContent
                    loading={odpConfigurationLoading}
                    data={odpConfiguration}
                    loadingText="Loading ODP configurations..."
                />
                
                <Maybe condition={odpConfigurationLoading === false}>
                    <form onSubmit={submitForm} className="mt-8">
                        <SelectInput label="Salary Date" required={true} value={form.payrollCutOff || ""} onChange={(e) => setForm({...form, payrollCutOff: e.target.value})}>
                            <option value="">Select date</option>
                            {[...Array(32).keys()].slice(1).map((ele, index) =>
                            <option key={index} value={ele}>{numberOrdinalSuffix(ele)}</option>
                            )}
                        </SelectInput>
                        
                        <SelectInput label="Withdrawal Fee" required={true} value={form.paymentFee || ""} onChange={(e) => setForm({...form, paymentFee: e.target.value})}>
                            <option value="">Select</option>
                            <option value="employer">Business</option>
                            <option value="employee">Employee</option>
                            {/* <option value="shared">Shared</option> */}
                        </SelectInput>
                        
                        <SelectInput 
                            label="Withdrawal Setup" 
                            required={true} value={form.autoWithdrawals || ""} 
                            onChange={(e) => setForm({...form, autoWithdrawals: e.target.value})}
                            tooltip={<>
                                <ul>
                                    <li>
                                        <b>Allow auto-withdrawals (with description saying:</b> employee can access their on-demand-salary without requiring any approval)
                                    </li>
                                    <li>
                                        <b>Require approval</b> (with a description to say "i will approve each withdrawal from my employee before they have access")
                                    </li>
                                </ul>
                            </>}
                        >
                            <option value="">Select Setup</option>
                            <option value="true">Allow Auto Withdrawal</option>
                            <option value="false">Require Approval</option>
                        </SelectInput>
                        
                        <SelectInput 
                            label="Employee Access (Percentage)" 
                            required={true} value={form.withdrawalPercent || ""} 
                            onChange={(e) => setForm({...form, withdrawalPercent: Number(e.target.value)})}
                            tooltip={<>
                                <ul>
                                    <li>
                                        This is the percentage that an On-Demand Pay Employee can acess
                                    </li>
                                </ul>
                            </>}
                        >
                            <option value="">Select Percentage</option>
                            <option value="50">50%</option>
                            <option value="75">75%</option>
                        </SelectInput>
                        
                        <div className="mt-10 flex justify-end space-x-4">
                            <button type="button" onClick={() => setIsOpen(false)} className="btn btn-lg btn-transparent-primary">
                                Cancel
                            </button>
                            <ButtonLoader type="submit" loading={updateODPConfigurationLoading} className="btn btn-lg btn-ep-primary">
                                Save
                            </ButtonLoader>
                        </div>
                    </form>
                </Maybe>
                
            </div>
        </FormDrawer>
    )
}


export default ODPConfiguration;